import privateAxiosInstance from "../components/shared/axios";

const resetPassword = async (password1, password2) => {
  let ResetPasswordURL = `${process.env.REACT_APP_BACKEND_URL}/auth/reset-password`;
  try {
    let response = await privateAxiosInstance.post(ResetPasswordURL, {
      password1,
      password2,
    });
    console.log("Reset Password Data:", response);
    return response.data;
  } catch (error) {
    console.log("Error resetting password in the user:", error);
    throw error.response;
  }
};

export default resetPassword;
